export default "./assets/4bed4a92e7b457d6fb7d115e45b68c81.svg";